import I18n from 'i18n-js';
import PropTypes, { instanceOf, number, oneOfType } from 'prop-types';

import ClockTimer from '~/components/ClockTimer';

import styles from './DailyRewardTimer.module.scss';

export default function DailyRewardTimer({ date, translation }) {
  return (
    <div className={styles.dailyRewardTimer}>
      {I18n.t(translation)}
      <ClockTimer
        date={date}
        className={styles.clock}
      />
    </div>
  );
}

DailyRewardTimer.propTypes = {
  date: oneOfType([instanceOf(Date), number]),
  translation: PropTypes.string,
};
